/* eslint-disable import/no-anonymous-default-export */
import classNames from "classnames";
import React, { useEffect, useState } from "react";
import Loader from "shared/Loader";
import LoadingContainer from "shared/LoadingContainer";
import PagingControls from "shared/PagingControls";
import Table from "shared/Table";
import formatDate from "shared/@utils/formatDate";
import styles from "./index.module.css";
import { useTransactions } from "./useTransactions";

export default function ({ iboNumber, events }) {
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(25);

  const { records, loading, refresh } = useTransactions({
    iboNumber,
    limit,
    page,
  });

  useEffect(() => {
    if (loading) {
      events.emit("refresh:start");
    } else {
      events.emit("refresh:end");
    }
  }, [loading]);

  // Listen for refresh events on mount and stop listening when unmounted.
  useEffect(() => {
    const listener = () => {
      refresh();
    };

    events.on("refresh", listener);

    return () => {
      events.removeListener("refresh", listener);
    };
  }, [refresh]);

  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div className={styles.container}>
      {records == null ? (
        <Loader />
      ) : (
        <LoadingContainer isLoading={loading}>
          <div className={styles.pagingControls}>
            <PagingControls
              page={page}
              limit={limit}
              onPageChange={setPage}
              onLimitChange={setLimit}
              disableNext={records.length === 0}
              disabled={loading}
            />
          </div>

          <Table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Invoice</th>
                <th>Amount</th>
                <th>Type</th>
                <th>Response</th>
                <th>Auth Code</th>
                <th>CC Last Four</th>
                <th>CC Exp.</th>
                <th>Merchant ID</th>
              </tr>
            </thead>
            <tbody>
              {records.map((m, i) => {
                return (
                  <tr
                    title={JSON.stringify(m, null, 2)}
                    key={i}
                    onMouseDown={() => {
                      setSelectedIndex(i);
                    }}
                    className={classNames(styles.resultRow, {
                      [styles.selected]: selectedIndex === i,
                    })}
                  >
                    <td>{formatDate(m.transactionDate)}</td>
                    <td>{m.invoice ? m.invoice : <Empty />}</td>
                    <td className={styles.nowrap}>
                      {m.amount ? m.amount.toFixed(2) : <Empty />}
                    </td>
                    <td>{m.typeAbbr ? m.typeAbbr : <Empty />}</td>
                    <td>{m.responseText ? m.responseText : <Empty />}</td>
                    <td>{m.authCode ? m.authCode : <Empty />}</td>
                    <td>{m.ccLastFour}</td>
                    <td>{m.ccExp}</td>
                    <td>{m.merchantId}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>

          <div className={styles.pagingControls}>
            <PagingControls
              page={page}
              limit={limit}
              onPageChange={setPage}
              onLimitChange={setLimit}
              disableNext={records.length === 0}
              disabled={loading}
            />
          </div>
        </LoadingContainer>
      )}
    </div>
  );
}

export function Empty() {
  return <span className={styles.emptyPlaceholder}>---</span>;
}
